module.exports = __webpack_public_path__ + "static/media/Gallery 2.c4f32c24.svg";